export default "__VITE_ASSET__BfANF2NM__"